import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PopoverComponent } from './popover.component';
import { PopoverDirective } from './popover.directive';
import { PopoverService } from './popover.service';

@NgModule({
	declarations: [PopoverComponent, PopoverDirective],
	imports: [CommonModule],
	providers: [PopoverService],
	exports: [PopoverComponent, PopoverDirective],
})
export class PopoverModule {}
